import React, { useEffect, useState } from 'react';
import Header from '../components/header';
import Material from '../components/material/index';
import Element from '../components/element';
import searchStore from '../searchStore';
import './index.less';

const SourceMaterial: React.FC<{}> = () => {
  const [activeKey, setActiveKey] = useState('element');

  useEffect(() => {
    return () => {
      searchStore.clearAll();
    };
  }, []);

  return (
    <div className="source-list-wrap">
      <Header title="公共素材管理" activeKey={activeKey} setActiveKey={setActiveKey} />
      <div className="source-content-wrap">
        <div className="source-page-wrap">
          {activeKey === 'material' ? <Material /> : <Element />}
        </div>
      </div>
    </div>
  );
};

export default SourceMaterial;
